import React from 'react';

import { confirmBefore, getDeleteActionMessage } from '../../utils/common.utils';

import { Action } from './ActionPanel';

import type { Pipe } from '../../types/pipes.types';
import type { System } from '../../types/system.types';
import type { Dataset } from '../../types/dataset.types';

import { TestID } from '../../testID';

/*
 * Delete action found on all list pages.
 */
export const DeleteAction: React.FC<{
  title: string;
  onDelete: () => void;
  selection: Pipe[] | System[] | Dataset[];
}> = ({ title, onDelete, selection }) => {
  const onClick = () => {
    const message = getDeleteActionMessage(selection, title);

    confirmBefore(message, onDelete);
  };

  return (
    <Action
      name="Delete…"
      theme="danger"
      onActionClick={onClick}
      enabled={selection?.length > 0}
      testId={TestID.DeleteActionButton}
    />
  );
};
